module.exports = __webpack_public_path__ + "mp.f077d4cd084b20588f06.svg";


//////////////////
// WEBPACK FOOTER
// D:/projects/feelway-pawnshop/pawnshop-web-client-feelway/src/assets/scss/icons/flag-icon-css/flags/mp.svg
// module id = ../../../../../src/assets/scss/icons/flag-icon-css/flags/mp.svg
// module chunks = styles